module.exports = __webpack_public_path__ + "static/media/sideBarStarFilled.eb3d4152.svg";